import { API_ROOT, LOGIN_URL, AUTH_URL, LOGOUT_URL, TOKEN_URL } from 'environment';
import sha256 from 'js-sha256';

class AuthService {
    isLoggedIn() {
        let token = window.localStorage.oauthAdminToken;
        return (typeof token === 'string' || token instanceof String);
    }

    isCallback() {
        let state = window.localStorage.oauthState;
        if (typeof state === 'string' || state instanceof String) {
            let params = parseQueryString(window.location.search.substring(1));
            let code = params.code;
            if ((params.state == state) && (typeof code === 'string' || code instanceof String)) return true;
            if ((params.state !== undefined) && (params.error)) return true;
        }
        return false;
    }

    redirectToLogin() {
        let state = generateRandomString(8)
        let verifier = generateRandomString(48)
        let challenge = b64(sha256.array(verifier))
        window.localStorage.oauthState = state;
        window.localStorage.oauthVerifier = verifier;
        window.localStorage.oauthAdminPath = window.location.href;
        window.location.replace(AUTH_URL+'&state='+state+'&code_challenge_method=S256&code_challenge='+challenge);
        throw new Error('halt');
    }

    handleCallback() {
        let params = parseQueryString(window.location.search.substring(1));
        if (params.code) {
            let code = params.code;
            let verifier = window.localStorage.oauthVerifier;
            params = parseQueryString(AUTH_URL.substring(AUTH_URL.indexOf('?') + 1));
            let data = `grant_type=authorization_code&client_id=${params.client_id}&redirect_uri=${params.redirect_uri}&code=${code}&code_verifier=${verifier}`;
            let post = $.ajax(TOKEN_URL, {'method': 'POST', 'data': data})
            post.done((resp) => {
                if (resp.token_type === 'bearer') {
                    let token = resp.access_token;
                    if (token && (token.length > 0)) {
                        window.localStorage.oauthAdminToken = token;
                        window.location.replace(window.localStorage.oauthAdminPath || '/');
                        throw new Error('halt');
                    }
                }
            });
            post.fail((resp) => {
                console.error('error '+resp.status+': '+resp.statusText );
                var error = 'unknown_error';
                var error_description = 'An unknown error occurred; network status code '+resp.status;
                var error_hint = '';
                var err = $.parseJSON(resp.responseText);
                if (typeof err === 'object') {
                    if (err['error']) error = err['error'];
                    if (err['error_description']) error_description = err['error_description'];
                    if (err['error_hint']) error_hint = err['error_hint'];
                }
                clearStorage(window.localStorage);
                let l = window.location;
                window.location.replace(LOGIN_URL+'/error?error='+encodeURIComponent(error)+
                    '&error_description='+encodeURIComponent(error_description)+
                    '&error_hint='+encodeURIComponent(error_hint)+
                    '&link='+encodeURIComponent('Return to BoxCast Admin')+
                    '&href='+encodeURIComponent(l.protocol+'//'+l.hostname+(l.port ? ':'+l.port : '')));
                throw new Error('halt');
            });
            return post;
        } else {
            clearStorage(window.localStorage);
            var error_url = LOGIN_URL+'/error?error='+params['error'];
            if (params['error_description']) error_url += '&error_description='+params['error_description'];
            if (params['error_hint']) error_url += '&error_hint='+params['error_hint'];
            window.location.replace(error_url);
            throw new Error('halt');
            return $.Deferred();
        }
    }

    logOut() {
        clearStorage(window.localStorage);
        window.location.replace(LOGOUT_URL);
        throw new Error('halt');
    }
}
export default AuthService
angular.module('app.services').service('AuthService', AuthService);

function parseQueryString(qs) {
    var params = {};
    let pairs = qs.split('&');
    for (var i = 0; i < pairs.length; i++) {
        let pair = pairs[i].split('=');
        params[pair[0]] = pair[1];
    }
    return params;
}

function generateRandomString(n) {
    var bytes = new Uint8Array(((n*3)+3)/4);
    crypto.getRandomValues(bytes);
    return b64(bytes).substring(0, n)
}

function b64(bytes) {
    return btoa(String.fromCharCode.apply(null, bytes))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function clearStorage(localStorage) {
    ['oauthAdminPath', 'oauthAdminToken', 'oauthState', 'oauthVerifier'].forEach((k) => localStorage.removeItem(k));
}



// WEBPACK FOOTER //
// ./services/auth_service.js